(function () {
    'use strict';

    const LS_KEY = 'bc-theme';
    const LS_VERSION_KEY = 'bc-theme-v';
    const LS_VERSION = '2';
    const DEFAULT_THEME = 'light';
    const root = document.documentElement;

    function readTheme() {
        try {
            if (localStorage.getItem(LS_VERSION_KEY) !== LS_VERSION) return DEFAULT_THEME;
            return localStorage.getItem(LS_KEY) || DEFAULT_THEME;
        } catch (_) {
            return DEFAULT_THEME;
        }
    }

    function writeTheme(t) {
        try {
            localStorage.setItem(LS_KEY, t);
            localStorage.setItem(LS_VERSION_KEY, LS_VERSION);
        } catch (_) {}
    }

    function repaintHooks() {
        if (typeof window._repaintSvgCharts === 'function') {
            try {
                window._repaintSvgCharts();
            } catch (_) {}
        }
        if (typeof window.paintDist === 'function') {
            const d = document.getElementById('distMain');
            if (d) {
                try {
                    window.paintDist(d);
                } catch (_) {}
            }
        }
    }

    function refreshToggles(theme) {
        document.querySelectorAll('[data-theme-set]').forEach(function (btn) {
            btn.classList.toggle('on', btn.dataset.themeSet === theme);
        });
    }

    function apply(theme, persist) {
        root.setAttribute('data-theme', theme);
        if (persist !== false) writeTheme(theme);
        refreshToggles(theme);
        repaintHooks();
        document.dispatchEvent(new CustomEvent('bc:themechange', { detail: { theme: theme } }));
    }

    function onSegmentedClick(e) {
        const btn = e.target.closest('button[data-theme-set]');
        if (!btn) return;
        apply(btn.dataset.themeSet);
    }

    function onSingleToggleClick() {
        apply(root.getAttribute('data-theme') === 'light' ? 'dark' : 'light');
    }

    function init() {
        // Pages without a toggle keep their own data-theme; don't apply the stored preference there.
        const hasToggle = ['themeToggle', 'spThemeToggle', 'drawToggleTheme'].some(function (id) {
            return document.getElementById(id) !== null;
        });

        if (hasToggle) {
            apply(readTheme(), false);
        }

        ['themeToggle', 'spThemeToggle'].forEach(function (id) {
            const el = document.getElementById(id);
            if (el) el.addEventListener('click', onSegmentedClick);
        });

        const single = document.getElementById('drawToggleTheme');
        if (single) single.addEventListener('click', onSingleToggleClick);

        // Route through apply(): it is the single place that dispatches bc:themechange.
        window.addEventListener('storage', function (e) {
            if (e.key === LS_KEY && e.newValue) {
                apply(e.newValue);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.bcTheme = {
        apply: apply,
        get: function () {
            return root.getAttribute('data-theme') || DEFAULT_THEME;
        },
    };
})();
